module.exports = __webpack_public_path__ + "static/media/IconModoE.c32ac8ac.svg";